var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCrossCancelCloseIconType1 = function SvgCrossCancelCloseIconType1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.975 14.003l8.799-8.799a1.398 1.398 0 10-1.977-1.977l-8.8 8.799-8.798-8.8A1.398 1.398 0 003.22 5.205l8.8 8.8-8.8 8.798A1.399 1.399 0 105.2 24.78l8.799-8.798 8.799 8.798a1.394 1.394 0 001.977 0 1.398 1.398 0 000-1.977l-8.799-8.799z",
    fill: "#fff",
    fillOpacity: 0.8
  })));
};
export default SvgCrossCancelCloseIconType1;